export const isSafariBrowser = () => {
  const ua = window?.navigator?.userAgent || '';

  return /iPad|iPhone/i.test(ua) && /WebKit/i.test(ua) && !/CriOS/i.test(ua);
};
